import React, { useState, useEffect } from 'react';
import Permiso from '../../components/sturtural/Permiso';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown'
import { storage } from '../../helpers/storage';

const grados = [
    { label: "1°", value: "1" },
    { label: "2°", value: "2" },
    { label: "3°", value: "3" }
];

const grupos = [
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "D", value: "D" },
    { label: "E", value: "E" },
    { label: "F", value: "F" },
    { label: "G", value: "G" },
];

const estatusOptions = [
    { label: 'Pendientes', value: 1 },
    { label: 'Entregados', value: 2 },
    { label: 'En lista de espera', value: 9 },
]

// inicio busqueda por folio
const initialFormFolio = {
    folio: ""
}

// busqueda por datos del alumno
const initialFormData = {
    curp: "",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    grado: grados[0].value,
    grupo: ""
}

// validacion formulario por folio
const validationsFromFolio = (folio) => {
    let errors = {};

    if (!folio.folio.trim()) {
        errors.folio = "El Campo (folio) es requerido";
    }
    return errors;
}

//validacion de formulario por datos
const validationsFromData = (data) => {
    let errors = {};

    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    let regexCurp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
    if (!data.grado.trim()) {
        if (!data.curp.trim()) {
            // if(!data.nombre.trim()) {
            //     errors.nombre = "El Campo (Nombre) es requerido";
            // }else
            if (!regexName.test(data.nombre.trim())) {
                errors.nombre = "El Campo (Nombre) es sólo acepta letras y espacios en blanco";
            }

            // if(!data.apellido_paterno.trim()) {
            //     errors.apellido_paterno = "El Campo (Primer Apellido) es requerido";
            // } else
            if (!regexName.test(data.apellido_paterno.trim())) {
                errors.apellido_paterno = "El Campo (Primer Apellido) es sólo acepta letras y espacios en blanco";
            }
        }

        if (!data.grupo.trim()) {
            errors.grupo = "el campo (Grupo) es reqerido"
        }
    }

    return errors;
}

// inicio agregar tutor
const initialFormNuevoTutor = {
    nombre: "",
    apellido1: "",
    apellido2: ""
}

//validacion de formulario tutor
const validationsFrom_NuevoTutor = (data) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;

    if (!data.nombre.trim()) {
        errors.nombre = "El Campo (Nombre) es requerido";
    } else if (!regexName.test(data.nombre.trim())) {
        errors.nombre = "El Campo (Nombre) no acepta números ni caracteres especiales";
    }

    if (!data.apellido1.trim()) {
        errors.apellido1 = "El Campo (Primer Apellido) es requerido";
    } else if (!regexName.test(data.apellido1.trim())) {
        errors.apellido1 = "El Campo (Primer Apellido) no acepta números ni caracteres especiales";
    }

    console.log(data.apellido2.trim())
    if (data.apellido2.trim()) {
        if (!regexName.test(data.apellido2.trim())) {
            errors.apellido2 = "El Campo (Segundo Apellido) no acepta números ni caracteres especiales";
        }
    } else {
        console.log("Campo Segundo Apellido no es obligatorio");
    }

    return errors;
}

const FiltroAlumno= () => {
    const navigate = useNavigate();

    const [folio, setFolio] = useState(initialFormFolio);
    const [errors, setErrors] = useState(true);
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState(initialFormData);
    const [dataErrors, setDataErrors] = useState(true);
    const [dataLoading, setDataLoading] = useState(false);

    const [tutor, setTutor] = useState(initialFormNuevoTutor);
    const [errors_nuevo_tutor, setErrors_NuevoTutor] = useState(true);
    const [loading_nuevo_tutor, setLoading_NuevoTutor] = useState(false);
    const [alumnoId, setAlumnoId] = useState(null);
    const [cupu, setCupu] = useState(null);

    const [alumnos, setAlumnos] = useState(null);
    const [lstAlumnos, setLstAlumnos] = useState(null);
    const [estatus, setEstatus] = useState(estatusOptions[0].value);
    const [tutores, setTutores] = useState(false);
    const [form_tutor, setFormAdd_tutor] = useState(false);

    const [lista, setLista] = useState(false);

    const [IdAlumno, setIdAlumno] = useState(null);
    const [IdTutor, setIdTutor] = useState(null);

    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);
    const [redirect, setRedirect] = useState(false);

    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    const perfil = storage.get('token');


    useEffect(() => {
        if (![1, 2, 5, 13, 16].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    const isNormalInteger = (str) => {
        let n = ~~Number(str);
        return String(n) === str && n >= 0;
    }

    useEffect(() => {
        if (lstAlumnos !== null) {
            Search(1)
        }
    }, [lstAlumnos])

    let { q } = useParams();
    useEffect(() => {
        //console.log(q);
        if (isNormalInteger(q)) {
            const arrUser = {
                "IdAlumno": 0,
                "Nombre": "",
                "ApellidoPaterno": "",
                "ApellidoMaterno": "",
                "Curp": "",
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": 0,
                "Codigo": "",
                "Grado": "",
                "Grupo": "",
                "IdTurno": 0,
                "IdTienda": 0,
                "Pagina": 1,
                "Folio": q,
                "IdEstatus": -1
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    setTutores(null);
                    setLstAlumnos(arrAlumnos);
                    setLista(true);

                    if (arrAlumnos[0].IdEstatus === 0) {
                        //handleFind_tutores_x_alumno(arrAlumnos[0].IdAlumno);
                    }
                } else {
                    setMessage("No se encontró información");
                    setLstAlumnos(null);
                    setAviso(true);
                }
            });
            setLoading(false);
        }
    }, [q]);

    const handlerRedirect = () => {
        if (redirect) {
            navigate("/pendientes");
        } else {
            setAviso(false);
            setMessage(false);
        }
    }

    const handleConfirmation = (_IdTutor, _IdAlumno) => {

        setIdTutor(_IdTutor);
        setIdAlumno(_IdAlumno);
        setDisplayConfirmation(true)
    }

    const handleFind_alumno_folio = async (e) => {
        e.preventDefault();

        setErrors(validationsFromFolio(folio));

        if (Object.keys(errors).length === 0) {

            const arrUser = {
                "IdAlumno": 0,
                "Nombre": "",
                "ApellidoPaterno": "",
                "ApellidoMaterno": "",
                "Curp": "",
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": 0,
                "Codigo": "",
                "Grado": "",
                "Grupo": "",
                "IdTurno": 0,
                "IdTienda": 0,
                "Pagina": 1,
                "Folio": Number(folio.folio),
                "IdEstatus": -1
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    setTutores(null);
                    setLstAlumnos(arrAlumnos);
                    setLista(true);
                } else {
                    setMessage("No se encontró información");
                    setLstAlumnos(null);
                    setAviso(true);
                }
                setLoading(false);
            });
        } else {
            console.log("(1) Error en la validación de campos");
            return;
        }
    };

    const handleFind_alumno_x_data = async (e) => {
        e.preventDefault();

        setDataErrors(validationsFromData(data));

        if (Object.keys(dataErrors).length === 0) {
            // if (data.nombre && data.apellido_paterno) {

            const arrUser = {
                "IdAlumno": 0,
                "Nombre": data.nombre,
                "ApellidoPaterno": data.apellido_paterno,
                "ApellidoMaterno": data.apellido_materno,
                "Curp": data.curp,
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": storage.get('IdTienda'),
                "Codigo": "",
                "Grado": data.grado,
                "Grupo": data.grupo,
                "IdTurno": 0,
                "IdTienda": storage.get('IdTienda'),
                "Pagina": 1,
                "Folio": "",
                "IdEstatus": -1
            };

            setDataLoading(true);

            console.log(arrUser)
            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                console.log(res)
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    setTutores(null);
                    setLstAlumnos(arrAlumnos);
                    setLista(true);
                } else {
                    setMessage("No se encontró información");
                    setLstAlumnos(null);
                    setAviso(true);
                }
            setDataLoading(false);
            });
            // } s

        } else {
            console.log("(2) Error en la validación de campos");
            return;
        }
    };

    const handleShowForm_NuevoTurtor = (_IdAlumno, _cupu) => {
        setAlumnoId(_IdAlumno);
        setCupu(_cupu);
        setFormAdd_tutor(true);
    }

    const carga = (_folio) => {
        const arrUser = {
            "IdAlumno": 0,
            "Nombre": "",
            "ApellidoPaterno": "",
            "ApellidoMaterno": "",
            "Curp": "",
            "NombreTutor": "",
            "ApellidoPaternoTutor": "",
            "ApellidoMaternoTutor": "",
            "OrderBy": "",
            "IdEscuela": 0,
            "Codigo": "",
            "Grado": "",
            "Grupo": "",
            "IdTurno": 0,
            "IdTienda": 0,
            "Pagina": 1,
            "Folio": _folio,
            "IdEstatus": -1
        };

        setLoading(true);

        helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
            body: arrUser,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            let arrAlumnos = res.Result;
            if (arrAlumnos?.length > 0) {
                setTutores(null);
                setLstAlumnos(arrAlumnos);
                setLista(true);
                if (arrAlumnos[0].IdEstatus === 1) {
                    //handleFind_tutores_x_alumno(arrAlumnos[0].IdAlumno);
                }
            } else {
                setMessage("No se encontró información");
                setLstAlumnos(null);
                setAviso(true);
            }
        });
        setLoading(false);
    }

    const handleSubmit_tutor = (e) => {
        e.preventDefault();

        setErrors_NuevoTutor(validationsFrom_NuevoTutor(tutor));

        if (Object.keys(errors_nuevo_tutor).length === 0) {

            if (tutor.nombre && tutor.apellido1) {

                const arrUser = {
                    "IdTipoTutor": 0,
                    "IdTutor": 0,
                    "Nombre": tutor.nombre,
                    "ApellidoPaterno": tutor.apellido1,
                    "ApellidoMaterno": tutor.apellido2,
                    "NombreTutor": "",
                    "NombreCompletoTutor": "",
                    "Telefono": "",
                    "Correo": "",
                    "Celular": "",
                    "Curp": "",
                    "TipoTutor": "",
                    "TelEmergencia": "",
                    "IdUsuario": storage.get('id'),
                    "IdAlumno": alumnoId
                }

                setLoading(true);

                helpHttp().post(`${BASE_API}Tutores/AltaTutor`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    },
                }).then((res) => {
                    if (res.isSuccess) {
                        let rtutor = res.Respuesta;
                        carga(cupu);

                        setTutor(initialFormNuevoTutor);
                    } else {

                    }
                    setFormAdd_tutor(false);
                    setTutor(initialFormNuevoTutor);
                });
                //setLoading(false);
            }

        } else {
            console.log("(3) Error en la validación de campos");
            return;
        }
    }

    const handleFind_tutores_x_alumno = (IdAlumno) => {

        const arrAlumno = {
            "IdAlumno": IdAlumno
        }

        helpHttp().post(`${BASE_API}BusquedaAlumnos/BuscarTutor`, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            let arrTutores = res;
            if (arrTutores?.length > 0) {
                setTutores(arrTutores);
                setIdAlumno(IdAlumno);

                //console.log("arrTutores: " + arrTutores);
            } else {
                //setMessage("No se encontraron tutores para este alumno");
                setTutores(false);
                //setIdAlumno(null);
            }
        });
    }

    const handlerAssign_pendientes = () => {
        const arrAlumno = {
            "IdEncEntrega": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdUsuario": storage.get('id'),
            "IdTutor": IdTutor,
            "Latitud": "29.08302909546271",
            "Longitud": "-110.99936963148365",
            "IdEstatus": 1,
            "alumnosId": [
                IdAlumno
            ],
            "OtroMotivoCancelacion": "",
            "IdAlumno": IdAlumno,
            "IdDocumento": 0
        }

        setLoading(true);


        helpHttp().post(`${BASE_API}Entrega/AgregarAListaEspera`, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            if (res.Id > 0) {
                navigate("/pendientes-alumno");
                //setRedirect(true);
                //handlerRedirect();
                //setMessage("Alumno enviado a la lista de pendientes");
                //setAviso(false);
            } else if (res.Id == 0) {
                setDisplayConfirmation(false)
                setMessage(res.MsgError);
                console.log(res.MsgError)
                setAviso(true);
            } else {
                setDisplayConfirmation(false)
                setMessage('Error de conexión, Favor de iniciar el proceso nuevamente');
                setAviso(true);
            }
            setLoading(false);
        });
    }

    // por folio
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFolio({
            ...folio,
            [name]: value,
        });
    };

    // por folio
    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFromFolio(folio));
    };

    // por data alumno
    const handleChangeData = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };

    // por data alumno
    const handleBlurData = (e) => {
        handleChangeData(e);
        setDataErrors(validationsFromData(data));
    };

    // por tutor
    const handleChange_NuevoTutor = (e) => {
        const { name, value } = e.target;
        setTutor({
            ...tutor,
            [name]: value,
        });
    };

    // por tutor
    const handleBlur_NuevoTutor = (e) => {
        handleChange_NuevoTutor(e);
        setErrors_NuevoTutor(validationsFrom_NuevoTutor(tutor));
    };

    /*const leftToolbarTemplate = () => {
        return (
            <form onSubmit={handleFind_alumno_folio}>
                <div className="formgroup-inline">
                    <div className="field">
                        <label htmlFor="folio" className="p-sr-only">CUPU:</label>
                        <InputText id="folio" name='folio' type="text" placeholder="folio" className={`w-full mb-3 ${errors.folio && 'p-invalid'}`} />
                        {errors.folio && <small className="p-error">{errors.folio}</small>}
                    </div>
                    {loading && <Loader />}
                    <Button type='submit' disabled={loading} label="Buscar"></Button>
                </div>

                <div className='text-center col-12'>
                    <div className="flex align-items-center justify-content-center">
                        <input placeholder="FOLIO" id="folio" name='folio' type="text" value={folio.folio} onChange={handleChange} onBlur={handleBlur} autoFocus className="p-inputtext p-component p-3 border-noround border-round-left" style={{"minWidth": "250px"}} />
                        <button className="p-button p-component border-noround border-round-right p-3 w-auto p-button-icon-only">
                            <span className="p-button-icon p-c pi pi-search"></span>
                            <span className="p-button-label p-c">&nbsp;</span>
                            <span role="presentation" className="p-ink" style={{"height": "55px", "width": "55px", "top": "-2.5px", "left": "-26.5px"}}></span>
                        </button>
                    </div>
                </div>

                <div className="col-12 md:col-12">
                    <div className="p-inputgroup">
                        <InputText placeholder="Keyword" />
                        <Button label="Search" />
                    </div>
                </div>
                    
            </form>
        )
    }*/

    const confirmationDialogFooter = (
        <>
            <div >
                <div>
                    <Button disabled={loading} label='No' className="p-button-outlined " icon='pi pi-times' onClick={() => setDisplayConfirmation(false)} />
                    <Button disabled={loading} label='Sí' className="p-button" icon='pi pi-check' onClick={() => handlerAssign_pendientes()} />
                </div>
            </div>
        </>
    );

    const handleClear_alumno_x_data = () => {
        setData(initialFormData);
    }

    const Search = (value) => {
        setEstatus(value)
        var text
        text = value;
        const arreglo = lstAlumnos.filter(function (o) {
            return ["IdEstatus"].some(function (k) {
                if (o[k] !== null) {
                    return o[k].toString().indexOf(text) !== -1;
                }
            });
        });
        console.log(arreglo)
        setAlumnos(arreglo)
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button" />;

    return (
        <>
            <Permiso perfil={5} />

            <Menu link='filtro' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        {perfil !== 16 && <form onSubmit={handleFind_alumno_folio} className="surface-section p-5 md:p-12 lg:p-12" name='form-folio' id="form-folio">
                            <div className="flex lg:align-items-start flex-column lg:flex-row p-4 bg-gray-100 border-round border-1 border-gray-200">
                                <div className="col-12 md:col-12">
                                    <div className="p-inputgroup">
                                        <InputText id="folio" name='folio' type="text" placeholder="Folio" value={folio.folio} onChange={handleChange} onBlur={handleBlur} className={`${errors.folio && 'p-invalid'}`} autoFocus />
                                        <Button type='submit' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-search')} label="Buscar" />
                                    </div>
                                    {errors.folio && <small className="p-error">{errors.folio}</small>}
                                </div>
                            </div>
                        </form>}

                        <TabView >
                            <TabPanel header="ESTUDIANTE">
                                <form onSubmit={handleFind_alumno_x_data} className="p-fluid" name="data" id="data">
                                    <div className="p-fluid formgrid grid mb-4">
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="curp">CURP:</label>
                                            <InputText id="curp" name="curp" type="text" value={data.curp} className={`w-full mb-3 ${dataErrors.curp && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.curp && <small className="p-error">{dataErrors.curp}</small>}
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="nombre">Nombre:</label>
                                            <InputText id="nombre" name="nombre" type="text" value={data.nombre} className={`w-full mb-3 ${dataErrors.nombre && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.nombre && <small className="p-error">{dataErrors.nombre}</small>}
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_paterno">Apellido paterno:</label>
                                            <InputText id="apellido_paterno" name="apellido_paterno" type="text" value={data.apellido_paterno} className={`w-full mb-3 ${dataErrors.apellido_paterno && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.apellido_paterno && <small className="p-error">{dataErrors.apellido_paterno}</small>}
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_materno">Apellido materno:</label>
                                            <InputText id="apellido_materno" name="apellido_materno" type="text" value={data.apellido_materno} className={`w-full mb-3 ${dataErrors.apellido_materno && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.apellido_materno && <small className="p-error">{dataErrors.apellido_materno}</small>}
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="grado">Grado:</label>
                                            <Dropdown id="grado" name="grado" disabled options={grados} optionLabel="label" optionValue="value" value={data.grado} className={`w-full mb-3 ${dataErrors.grado && 'p-invalid'}`} onChange={handleChangeData} />
                                            {dataErrors.grado && <small className="p-error">{dataErrors.grado}</small>}
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="grupo">Grupo:</label>
                                            <Dropdown id="grupo" name="grupo" options={grupos} optionLabel='label' optionValue='value' value={data.grupo} className={`w-full mb-3 ${dataErrors.grupo && 'p-invalid'}`} onChange={handleChangeData} />
                                            {dataErrors.grupo && <small className="p-error">{dataErrors.grupo}</small>}
                                        </div>

                                        <div className="field col-12 md:col-12">
                                            <div className="border-top-1 surface-border pt-3 flex" style={{justifyContent: 'end'}}>
                                                <button type="button" aria-label="Borrar" className="p-button p-component p-button-outlined mr-2" style={{width: 'auto'}} onClick={() => handleClear_alumno_x_data()}>
                                                    <span className="p-button-label p-c">Limpiar</span><span role="presentation" className="p-ink"></span>
                                                </button>
                                                
                                                <Button type='submit' label='Buscar' name='button-data' id='button-data' loading={dataLoading} className='p-button p-component ml-2' style={{width: 'auto'}} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                            {/*<TabPanel header="TUTOR">
                                <div className="p-fluid">
                                    <div className="p-fluid formgrid grid mb-4">
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="nombre">Nombre:</label>
                                            <InputText id="nombre" name="nombre" value="" />
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_paterno">Apellido Paterno:</label>
                                            <InputText id="apellido_paterno" name="apellido_paterno" value="" />
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_materno">Apellido Materno:</label>
                                            <InputText id="apellido_materno" name="apellido_materno" value="" />
                                        </div>
                            
                                        <div className="field col-12 md:col-12">
                                            <div className=" border-top-1 surface-border pt-3 flex">
                                                <button aria-label="Borrar" className="p-button p-component p-button-outlined w-6 mr-2">
                                                    <span className="p-button-label p-c">Borrar</span><span role="presentation" className="p-ink"></span>
                                                </button>
                                                
                                                <button aria-label="Buscar" className="p-button p-component w-6 ml-2">
                                                    <span className="p-button-label p-c">Buscar</span><span role="presentation" className="p-ink"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>    
                            </TabPanel>*/}
                        </TabView>
                    </div>
                </div>
            </div>

            <Dialog header="LISTADO DE ALUMNOS" draggable={false} visible={lista} style={{ width: '95%' }} modal onHide={() => setLista(false)}>
                <div className="grid">
                    <div className='col-12 lg:col-12 p-3 flex flex-column gap-2'>
                        <label htmlFor='estatus' style={{fontWeight: '500'}}>Estatus:</label>
                        <Dropdown id='estatus' value={estatus} options={estatusOptions} optionLabel='label' optionValue='value' onChange={(e) => { Search(e.value) }} />
                    </div>
                    {alumnos && alumnos.length > 0 ? alumnos.map((el, index) =>
                        <div className="col-12 lg:col-12 p-3 shadow-5 surface-card" key={index} style={{ marginBottom: '10px' }}>
                            <div className="p-3 border-round  flex align-items-center">
                                <div className={`${(el.IdEstatus === 2 ? 'bg-orange-100' : 'bg-green-100')} inline-flex align-items-center justify-content-center mr-3`} style={{ 'width': ' 48px', 'height': '48px', 'borderRadius': '10px' }}>
                                    <i className={`pi ${(el.IdEstatus === 2 || el.IdEstatus === 9 ? 'pi-lock' : 'pi-lock-open')} ${(el.IdEstatus ? 'text-orange-600' : 'text-green-600')} text-3xl`}></i>
                                </div>
                                <div>
                                    <span className="text-900 text-xl font-medium mb-2">{el.Curp} - {el.NombreCompleto}</span>
                                    {/* <p className="mt-1 mb-0 text-600 font-medium text-sm">CUPU: <strong>{el.CUPU}</strong></p> */}
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">ESCUELA: <strong>{el.Escuela}</strong></p>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">CLAVE CT: <strong>{el.Codigo}</strong></p>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">ESTATUS: <strong>{el.Estatus}</strong></p>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">GRADO Y GRUPO: <strong>{el.Grado} {el.Grupo}</strong></p>

                                </div>
                                <div className="ml-auto">
                                    {(el.IdEstatus === 1
                                        ?
                                        ([13, 16].includes(perfil) ? <Button icon="pi pi-plus" label="Agregar tutor" onClick={() => handleShowForm_NuevoTurtor(el.IdAlumno, el.CUPU)} ></Button> : "")
                                        : el.IdEstatus !== 9 &&
                                        <Button label="Ver Detalle" icon="pi pi-search" onClick={() => navigate(`/resumen-alumno/${el.IdAlumno}`)}></Button>)}
                                </div>
                            </div>
                            {(parseInt(el.IdEstatus) === 1 && el.lstTutor !== null
                                ?
                                (el.lstTutor.length > 0
                                    ?
                                    <>
                                        <p className="text-700 font-medium mb-1">SELECCIONAR TUTOR</p>
                                        <div className="flex pt-3">
                                            {el.lstTutor.map((elle, indey) =>
                                                <div className="w-6 pr-2" key={indey}>
                                                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handleConfirmation(elle.IdTutor, el.IdAlumno)}>
                                                        <span className="p-button-icon p-c pi pi-user"></span> <span>&nbsp;{elle.NombreTutor}</span>
                                                        <span className="p-button-label p-c">&nbsp;</span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                    :
                                    <MessageDetail color='warn' mensaje="DEBE AGREGAR TUTOR" />
                                )
                                :
                                "Holi"
                            )}
                        </div>
                    ) :
                        <div className='col-12 lg:col-12 p-3 mt-3'>
                            <h4>No se han encondrado resultados.</h4>
                        </div>}
                </div>
            </Dialog>

            <Dialog header="Agregar Tutor" visible={form_tutor} style={{ width: '95vw' }} modal onHide={() => setFormAdd_tutor(false)}>
                <form onSubmit={handleSubmit_tutor} className="col-12">
                    <div className="row">
                        <h4>Los campos marcados con asterisco son obligatorios</h4>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-12">
                                <label htmlFor="nombre">Nombre(s) <b style={{ "fontSize": "20px" }}>*</b>:</label>
                                <InputText id="nombre" name="nombre" type="text" value={tutor.nombre} onChange={handleChange_NuevoTutor} onBlur={handleBlur_NuevoTutor} className={errors_nuevo_tutor.nombre && 'p-invalid'} />
                                {errors_nuevo_tutor.nombre && <small className="p-error">{errors_nuevo_tutor.nombre}</small>}
                            </div>

                            <div className="field col-12 md:col-12">
                                <label htmlFor="apellido1">Primer Apellido <b style={{ "fontSize": "20px" }}>*</b>:</label>
                                <InputText id="apellido1" name="apellido1" type="text" value={tutor.apellido1} onChange={handleChange_NuevoTutor} onBlur={handleBlur_NuevoTutor} className={errors_nuevo_tutor.apellido1 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido1 && <small className="p-error">{errors_nuevo_tutor.apellido1}</small>}
                            </div>

                            <div className="field col-12 md:col-12">
                                <label htmlFor="apellido2">Segundo Apellido:</label>
                                <InputText id="apellido2" name="apellido2" type="text" value={tutor.apellido2} onChange={handleChange_NuevoTutor} onBlur={handleBlur_NuevoTutor} className={errors_nuevo_tutor.apellido2 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido2 && <small className="p-error">{errors_nuevo_tutor.apellido2}</small>}
                            </div>
                        </div>

                        <div className="px-4 py-3 surface-100 text-right">
                            {loading && <div>DAS<Loader /></div>}
                            <Button type="submit" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-circle-right')} value="Enviar" label="Guardar" className="mr" align="right"></Button>
                        </div>
                    </div>
                </form>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" visible={displayConfirmation} draggable={false} closable={false} onHide={() => setDisplayConfirmation(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con identificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="AVISO" visible={aviso} draggable={false} closable={false} style={{ width: '400px' }} modal className="p-fluid" onHide={() => handlerRedirect()} footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default FiltroAlumno;